import { Box, Center, VStack } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import useScreen from "../../hooks/useScreen";
import useSession from "../../hooks/useSession";
import { useHangExperienceColor } from "../../utils/hangExperience/hangExperienceColor";
// import { Color } from "../../interfaces/HairTransfer";
import { ColorItem as IColorItem } from "../../interfaces/Config";
import { State } from "../../interfaces/State";
import { Channel } from "../../interfaces/tracking";
import { AppDispatch } from "../../reducers/configureStore";
import {
  setCountClickCategoryColor,
  setCountClickColor,
} from "../../reducers/global/globalSlice";
import {
  setGenomeIds,
  setSelectedColor,
  setSelectedSubColor,
  setShowSmallLoader,
} from "../../reducers/volume/volumeSlice";
import { Analytics, EventNames } from "../../utils/tracking";

export interface ColorItemProps {
  color: any;
  selected: boolean;
  colorList: any;
  screen: string;
  disable?: boolean;
  isByColor?: boolean;
}

export const ColorItem = (props: ColorItemProps) => {
  const { color, selected, disable, isByColor } = props;
  const { selectedSubColor } = useSelector((state: State) => state.volume);
  const { isMobile } = useScreen();
  const { isLoggedIn } = useSession();
  const dispatch = useDispatch<AppDispatch>();

  const { countClickCategoryColor } = useSelector(
    (state: State) => state.global
  );

  const onHandleClick = () => {
    dispatch(setShowSmallLoader(true));
    dispatch(setSelectedColor(color));
    dispatch(setSelectedSubColor(color.colors ? color.colors[0] : undefined));
    const order = countClickCategoryColor + 1;
    const platform: string =
      new URLSearchParams(location.search).get("platform") ?? "";
    Analytics.event(Channel.GA, EventNames.COLOR_CATEGORY_SELECTED, {
      device: platform.includes("g-mob")
        ? "app"
        : isMobile
        ? "mobile"
        : "desktop",
      name: color?.name,
      position: color?.position,
      order: order,
      type: isByColor ? "color" : "brand",
      login: isLoggedIn(),
    });

    const { product } = selectedSubColor;
    const colorOrBrand = isByColor ? "color" : "brand";

    Analytics.event(Channel.TEALIUM, EventNames.SELECT_CONTENT, {
      page_name: "hair color try on",
      page_type: "virtual try-on",
      page_group: "virtual try-on",
      component_title: `${colorOrBrand} click`,
      action_type: "button",
      action_label: color?.name,
      tryon_hair_color: selectedSubColor.id,
      product_id: [`${product.id}`],
      product_sku: [`${product.sku}`],
      product_name: [`${product.productName}`],
      product_brand: [`${product.brandName}`],
      product_variant_color: [`${product.colorName}`],
    });

    dispatch(setCountClickCategoryColor(order));
    dispatch(setCountClickColor(0));

    const genomeId = color.colors?.map((color: IColorItem) => color.id);
    dispatch(setGenomeIds(genomeId?.join(",") || ""));

    useHangExperienceColor({ color: color.name });
  };

  return (
    <Box
      as={VStack}
      alignItems="center"
      cursor="pointer"
      onClick={disable ? () => {} : onHandleClick}
      paddingTop="4px"
      paddingBottom="4px"
      width="wrap-content"
      height="wrap-content"
      display={"flex"}
      _hover={
        !disable
          ? {
              transform: "scale(1.05)",
              transition: "transform 0.25s",
            }
          : undefined
      }
    >
      <Center
        border={selected ? "1px solid #505050" : "1px solid #E6E6E6"}
        borderRadius="full"
        display={"flex"}
      >
        <Center
          bgImage={`url(${process.env.PUBLIC_URL}/assets/images/${
            color?.resId ? `brands/${color?.resId}` : "colorItemWhite.svg"
          })`}
          border={"3px solid #FFFFFF"}
          bgSize={isByColor ? { base: 30, md: 40 } : "85%"}
          bgColor={color.hex ? color.hex : "#fff"}
          opacity={disable ? 0.5 : undefined}
          bgPosition="center"
          bgRepeat="no-repeat"
          borderRadius="full"
          height={isMobile ? "66px" : "78px"}
          width={isMobile ? "66px" : "78px"}
        />
      </Center>
      <Box
        as="span"
        display="inline-block"
        textAlign="center"
        fontSize={"14px"}
        lineHeight="15px"
        letterSpacing="0.2px"
        fontWeight="normal"
      >
        {color.name === "undefined"
          ? ""
          : `${color.name.charAt(0).toUpperCase()}${color.name.slice(1)}`}
      </Box>
      {!isByColor && color?.isSalon && (
        <Box
          as="span"
          display="inline-block"
          color={"#6A6A6A"}
          textAlign="center"
          fontSize={"12px"}
          lineHeight="4px"
          letterSpacing="0.2px"
          fontWeight={450}
        >
          {`Salon`}
        </Box>
      )}
    </Box>
  );
};
